import { createSafetyStorages } from '@mail-core/std/storage';
import { xray } from 'lib/xray';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';

export const [safetyPersonalLocalStorage, safetyPersonalSessionStorage, safetyPersonalRuntimeStorage] = createSafetyStorages({
    disabled: false,
    keyPattern: (key) => `${USER_EMAIL || ''}|${key}`,
    // eslint-disable-next-line max-params
    onerror: (storage, method, error, key, value) => {
        xray.send(`stg-${storage}-${method}`, {
            rlog: 'cloud_app_storage_err',
            rlog_message: {
                storage,
                method,
                key,
                value,
                error,
            },
        });
    },
});
